import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Grid } from '@material-ui/core';

import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../context/sidebar/sidebar.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import FAQ from './FAQ.component';

const UserFAQ = () => {
  const { user } = useAuthDataContext();
  const { setStepperTitle } = useSidebarContext();

  useEffect(() => {
    dataLayerPush('Inicio_atencion_consultas', user?.id);
    setStepperTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dataLayerPush('atencion_consultas', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();

  return (
    <>
      <StepperSubHeader goBack={() => history.goBack()}></StepperSubHeader>

      <Grid container justify="center" alignItems="center">
        <Grid item xs={11}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} sm={11} md={10} lg={9}>
              <FAQ></FAQ>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default UserFAQ;
